module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.eea1b98.eot";